import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ItemSearchResult } from './item-search/item-search.component';
import { HttpClient } from '@angular/common/http';
import { HomeService } from './home.service';

@Component({
  selector: 'app-home',
  standalone: false,
  templateUrl: './home.component.html',
  styleUrl: './home.component.css'
})
export class HomeComponent implements OnInit {

    initializing = true;
    query = '';
    skuToConfigure = '';
    
    brands: { name: string, id: number }[] = [];
 
    constructor( private router: Router, private http: HttpClient,
        private route: ActivatedRoute, public homeService: HomeService
     ) {
        
    }
    
    ngOnInit(): void {
        
        this.http.get<{ name: string, id: number }[]>( 'api/home/brands' )
        .subscribe( result => {
           this.brands = result;
           
           if ( !this.homeService.brandId ) {
             this.homeService.brandId = this.brands[0].id;
             this.updateBrandItems();
           }
           
           this.initializing = false;
        });
    
    }
    
    updateBrandItems() {
        
        this.homeService.brandId = parseInt( <any>this.homeService.brandId, 10 );
        
        this.http.get<Item[]>( `api/home/${this.homeService.brandId}/items` )
        .subscribe( result => {
           
           this.homeService.currentItems.length = 0;
           this.homeService.previousItems.length = 0;
            
           result.forEach( i => { 
             i.sku = encodeURIComponent( i.sku );
             
             if ( i.generation === 'Current' ) {
                this.homeService.currentItems.push( i );
             } else {
                this.homeService.previousItems.push( i );
             }
             
           } );
           
           if ( !this.initializing ) {
             this.setDeviceFilter( this.homeService.deviceType || 'A3 MFPs' );
           }
        });
    }
    
    selectSearchResult( item: ItemSearchResult ): void {
        
        if ( item ) {
            this.skuToConfigure = item.sku;
        } else {
            this.skuToConfigure = '';
        }
    }
    
    getDeviceFilters(): string[] {
        
        const filters: string[] = [];
        
        this.homeService.currentItems.forEach( i => {
           
            if ( filters.indexOf( i.deviceType ) === -1 ) {
                filters.push( i.deviceType );
            }
             
        });
        this.homeService.previousItems.forEach( i => {
                  
           if ( filters.indexOf( i.deviceType ) === -1 ) {
               filters.push( i.deviceType );
           }
            
       });
        
        const order = [
            'A3 MFPs',
            'A4 MFPs',
            'MFPs',
            'SFPs',
            'MICR',
            'Laser Printers',
            'Thermal',
        ];
        
        return filters.sort( ( a, b ) => {
            let oA = order.indexOf( a );
            let oB = order.indexOf( b );
            
            if ( oA === -1 ) {
                return 1;
            } else if ( oB === -1 ) {
                return -1;
            }
            
            return oA - oB;
        });
    }
    
    getFilterGroups(): string[] {
            
        const filters: string[] = [];
        
        this.getFilteredCurrentItems( true ).forEach( i => {
           
            i.filterGroups.forEach( f => {
                if ( filters.indexOf( f ) === -1 ) {
                    filters.push( f );
                }
            });
        });
        
        this.getFilteredPreviousItems( true ).forEach( i => {
                   
            i.filterGroups.forEach( f => {
                if ( filters.indexOf( f ) === -1 ) {
                    filters.push( f );
                }
            });
        })
        
        if ( filters.length < 2 ) {
            return [];
        }
        
        const order = [
            'Mono',
            'Color'
        ];
        
        return filters.sort( ( a, b ) => {
            
            let oA = order.indexOf( a );
            let oB = order.indexOf( b );
            
            if ( oA === -1 ) {
                return 1;
            } else if ( oB === -1 ) {
                return -1;
            }
            
            return oA - oB;
        });
    }
    
    setDeviceFilter( filter: string ): void {
        
        if ( filter === this.homeService.deviceType || 
                this.getDeviceFilters().indexOf( filter) === -1 ) {
            this.homeService.deviceType = '';
        } else {
            this.homeService.deviceType = filter;
        }
        
        this.homeService.filterGroups.length = 0;
    }
    
    setFilterGroup( filter: string ): void {
        
        // unless we get more filters, maybe only 
        // allow filtering by one
        this.homeService.filterGroups.length = 0;
        
        if ( !!this.homeService.filterGroups.find( f => f === filter ) ) {
            
            this.homeService.filterGroups.splice( this.homeService.filterGroups.indexOf( filter ), 1 );
            
        } else {
            this.homeService.filterGroups.push( filter );
        }
    }
    
    getFilteredCurrentItems( byDeviceOnly?: boolean ): Item[] {
        
        return this.filterItems( this.homeService.currentItems, byDeviceOnly );
        
    }
    
    getFilteredPreviousItems( byDeviceOnly?: boolean ): Item[] {
            
        return this.filterItems( this.homeService.previousItems, byDeviceOnly );
        
    }
    
    private filterItems( items: Item[], byDeviceOnly?: boolean ): Item[] {
        return items.filter( i => {
                   
            let match = !this.homeService.deviceType || i.deviceType === this.homeService.deviceType;
            
            if ( match && !byDeviceOnly ) {
                
                if ( this.homeService.filterGroups.length ) {
                    
                    for (let j = 0; j < this.homeService.filterGroups.length && match; j++) {
                        
                        match = !!i.filterGroups.find( g => this.homeService.filterGroups[j] === g );
                    }
                }
            }
            
            return match;
        });
    }
    
    configure( sku?: string ): void {
        
        this.router.navigate( [ 'configure', sku ? sku : this.skuToConfigure ] ) ;
        
    }
       
}

export interface Item {
    sku: string;
    generation: string;
    description: string;
    deviceType: string;
    filterGroups: string[];
}
